




































import { Component, Vue, Watch } from 'vue-property-decorator'

import { DataOptions } from 'vuetify'

import { getSpelling } from '@/tools/spelling'
import { mock } from '@/tools'
import { points } from '@/store/modules/points/index'
import { historyPoints } from '@/store/modules/points/history'

import { TransactionsHistory } from '@/api'

@Component
class BonusesView extends Vue {
  pointsModule = points.context(this.$store)
  historyPointsModule = historyPoints.context(this.$store)

  feedbackLink = `${process.env.VUE_APP_PORTAL_LINK}?f=feedback`

  get totalBonuses() {
    return getSpelling(this.pointsModule.state.points, 'балл', 'балла', 'баллов')
  }

  get options() {
    return this.historyPointsModule.state.tableOptions
  }

  set options(options: DataOptions) {
    this.historyPointsModule.mutations.setTableOptions(options)
  }

  @Watch('options', { immediate: false, deep: true })
  async updateTable() {
    await this.historyPointsModule.actions.getTableItems().catch(mock)
  }

  getType(isAccrual: boolean): string {
    if (isAccrual) {
      return 'Начисление'
    }
    return 'Списание'
  }

  getBonusesClass(isAccrual: boolean): string {
    if (isAccrual) {
      return 'success--text'
    } else {
      return 'error--text'
    }
  }

  getBonuses(item: TransactionsHistory): string {
    if (item.isAccrual) {
      return `+ ${getSpelling(item.numberOfPoints, 'балл', 'балла', 'баллов')}`
    }
    return `- ${getSpelling(item.numberOfPoints, 'балл', 'балла', 'баллов')}`
  }

  async created(): Promise<void> {
    await this.pointsModule.actions.getPoints().catch(mock)
  }
}

export default BonusesView
